import "../styles/default.scss";

import React from "react";

import useIsDesktop from "../../../hooks/useIsDesktop";
import PlanBoxCollapsed from "./PlanBoxCollapsed";
import PlanBoxSquare from "./PlanBoxSquare";

const PlanBox = ({
  plan,
  isCurrentPlan,
  isSelectedPlan,
  onSelect,
  isAvailableInPlan,
  isRecommendedPlan,
  isHighlightedPlan,
  period = 12,
  showBorder,
  selectedPaymentMethod
}) => {
  const isDesktop = useIsDesktop();

  return isDesktop ? (
    <PlanBoxSquare
      plan={plan}
      isSelectedPlan={isSelectedPlan}
      isCurrentPlan={isCurrentPlan}
      onSelect={onSelect}
      period={period}
      isAvailableInPlan={isAvailableInPlan}
      isRecommendedPlan={isRecommendedPlan}
      isHighlightedPlan={isHighlightedPlan}
      selectedPaymentMethod={selectedPaymentMethod}
    />
  ) : (
    <PlanBoxCollapsed
      plan={plan}
      isSelectedPlan={isSelectedPlan}
      isCurrentPlan={isCurrentPlan}
      onSelect={onSelect}
      period={period}
      isAvailableInPlan={isAvailableInPlan}
      showBorder={showBorder}
      isRecommendedPlan={isRecommendedPlan}
      isHighlightedPlan={isHighlightedPlan}
      selectedPaymentMethod={selectedPaymentMethod}
    />
  );
};

export default PlanBox;
